/// <amd-module name="Wit/WorkItems/TelemetryConstants" />
export namespace Area {
    export const WIT = "WIT";
}

export namespace Feature {
    export const WorkItem = "WorkItem";
}
